// extracted by mini-css-extract-plugin
export default {"loading":"leK4l","fade-out":"ctCQw","rose-spin":"JSsRh","rose-bloom":"RDtiS"};